// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__tarws","col":"Table_col__2CbAs","fulfillmentStatus":"Table_fulfillmentStatus__1xvy2","emailCol":"Table_emailCol__3uCu4"};